<script setup>
import ModalBrandPromo from '@/components/ModalBrandPromo.vue';
import ToastHost from '@/components/base/ToastHost.vue';

</script>

<template>
  <Suspense>
    <ModalBrandPromo :autoOpen="false" />
  </Suspense>
  <ToastHost />
</template>
